import { useMutation } from '@tanstack/react-query';

import type {
  VendorDetailsCreateSchema,
  VendorDetailsQuerySchema,
  VendorDetailsUpdateSchema,
} from '@/_pages/settings/inventory-kits/shared/schemas/vendor-details';
import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

export const useCreateVendorDetailsMutation = () =>
  useMutation<{ data: VendorDetailsQuerySchema }, ApiError, VendorDetailsCreateSchema>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/vendor-details/',
        payload,
      }),
  });

export const useUpdateVendorDetailsMutation = () =>
  useMutation<{ data: VendorDetailsQuerySchema }, ApiError, Partial<VendorDetailsUpdateSchema>>({
    mutationKey: ['VENDOR_DETAILS_UPDATE'],
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/vendor-details/${payload.id}`,
        method: 'PUT',
        payload,
      }),
  });

export const useDeleteVendorDetailsMutation = () =>
  useMutation<{ data: boolean }, unknown, { id: string }>({
    mutationKey: ['VENDOR_DETAILS_DELETE'],
    mutationFn: ({ id }) =>
      apiClient.request({
        endpoint: `/api/v1/vendor-details/${id}`,
        method: 'DELETE',
        payload: {},
      }),
  });
